import styled from 'styled-components';

export const FormActionsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-top: 16px;
`;
